import request from '@/utils/request'

export function userCourse(userid) {
    return request({
        url: `api/personalUser/userCourse?userid=${userid}`,
        method: 'get',
    })
}